// extracted by mini-css-extract-plugin
export default {"root":"EditorButtonBar-module--root--781e3"};